var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { Row, Col } from "@riseart/antd-provider";
import { CloseIcon, InfoIcon, SuccessIcon, WarningIcon, ErrorIcon } from "@riseart/icons";
import { Heading } from "../../heading/Heading";
import { Paragraph } from "../../layout/Paragraph";
import { notificationCls, notificationInfoCls, notificationSuccessCls, notificationWarningCls, notificationErrorCls, notificationCloseCls } from "./Message.less";
import { messageIconWrapperCls } from "../styles.less";
var NotificationMessage = /* @__PURE__ */ __name(function NotificationMessage2(_ref) {
  var _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$type = _ref.type, type = _ref$type === void 0 ? "info" : _ref$type, onClose = _ref.onClose;
  var TYPE_TO_CLASSNAME = {
    info: notificationInfoCls,
    success: notificationSuccessCls,
    warning: notificationWarningCls,
    error: notificationErrorCls
  };
  var TYPE_TO_ICON = {
    info: InfoIcon,
    success: SuccessIcon,
    warning: WarningIcon,
    error: ErrorIcon
  };
  var MessageIcon = type && TYPE_TO_ICON[type] || TYPE_TO_ICON.info;
  return /* @__PURE__ */ React.createElement(Row, {
    align: "middle",
    justify: "space-around",
    className: classNames(notificationCls, type && TYPE_TO_CLASSNAME[type])
  }, /* @__PURE__ */ React.createElement(Col, {
    xs: 2,
    sm: 4,
    className: messageIconWrapperCls
  }, /* @__PURE__ */ React.createElement(MessageIcon, null)), /* @__PURE__ */ React.createElement(Col, {
    span: 18
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h1",
    level: "4"
  }, title), items && items.map(function(message, key) {
    return /* @__PURE__ */ React.createElement(Paragraph, {
      key
    }, message);
  })), /* @__PURE__ */ React.createElement(CloseIcon, {
    className: notificationCloseCls,
    onClick: onClose
  }));
}, "NotificationMessage");
export {
  NotificationMessage
};
